import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import * as CheckoutActions from './checkout.actions';
import { from, of } from 'rxjs';
import { CheckoutService } from '../services/checkout.services';
import { Router } from '@angular/router';
import { shoppingCartActions } from '../../shoppingCart/store/shoppingCart.actions';
import * as OrderActions from '../../order/store/order.actions';

@Injectable()
export class CheckoutEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private checkoutService: CheckoutService
  ) {}

  getCartDataEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckoutActions.paymentRegister),
      switchMap((action) =>
        this.checkoutService.registerPayment(action.orderId, action.sessionId).pipe(
          filter(order => order?.id !== undefined && order?.id !== null),
          map(order => OrderActions.getOrderData({orderId: order.id.toString()})),
          catchError(() => of(CheckoutActions.paymentRegisterFailure({ error: 'Error registering payment data' })))
        )
      )
    )
  );
}
